import {useUserStore} from '~/store/user';
import {navigateTo} from '#app';
import Cookies from 'js-cookie';
import {FetchError} from 'ofetch';

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.shouldAuthenticate === false) return;

  const userStore = useUserStore();
  const requiresAuth = to.meta.layout !== 'auth';

  if (import.meta.client && userStore.isAuthenticated) {
    const expiry = Date.parse(Cookies.get('token_expires') || '');
    if (!Number.isFinite(expiry) || expiry <= Date.now() + 60 * 60 * 1000) {
      try {
        await userStore.refreshToken();
      } catch (error) {
        if (!(error instanceof FetchError) || error.statusCode !== 401) throw error;
        await userStore.logout();
      }
    }
  }

  if (requiresAuth && !userStore.isAuthenticated) {
    return navigateTo(`/?redirect=${encodeURIComponent(to.fullPath)}`);
  }

  // MFA enrollment/reset pages must remain reachable by an authenticated user.
  if (to.path === '/' && userStore.isAuthenticated) {
    return navigateTo('/documents');
  }
});